import React, { Component } from 'react';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';
import { Grid } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Security, LoginCallback, SecureRoute } from '@okta/okta-react';

import {
  addAlert,
  removeAlert,
  setNewUser,
  setUser,
} from '../actions';
import {
  getCognitoId
} from "../libs/auth";
import {
  createStudent,
  fetchStudent,
  fetchPeriods,
} from "../libs/apiCalls";
import oktaConfig from '../config/okta';

import Application from './Application';
import ApplicationForm from './ApplicationForm';
import Applications from './Applications';
import Information from './Information';
import ApplicationInformation from './ApplicationInformation';
import Notifications from './Notifications';
import Menu from './Menu';
import Footer from './Footer';
import Initiate from './Initiate';

import '../styles/App.css';
import * as actions from "../actions/types";
import * as constants from "../config/constants";
import { debugLog } from "../libs/utilities";
import { messages } from "../config/constants";

class App extends Component {
  constructor(props){
    super(props);
    this.state = {};
    this.handleDismissAlert = this.handleDismissAlert.bind(this);
    this.handleCreateApplication = this.handleCreateApplication.bind(this);
    this.setUser = this.setUser.bind(this);
    // Required for Security component of okta-react
    this.restoreOriginalUri = async (_oktaAuth) => {
      //props.history.replace(toRelativeUrl(originalUri, window.location.origin));
      // originalUri isn't set for some reason so just dump to root
      props.history.replace('/');
    };
  }

  async handleCreateApplication(periodId) {
    // If user is being created, check to see if done
    if(this.props.newUser) {
      const user = await this.setUser();
      if (!user.complete) {
        this.props.dispatch(addAlert('danger', 'Cannot begin application, account setup in progress.'));
        return;
      }
    }
    const { address, dateOfBirth, email, name, phones, ethnicity, gender, deltaId } = this.props.user;
    const basic = {
      address,
      dateOfBirth,
      email,
      name,
      phones,
      ethnicity,
      gender,
      deltaId
    };
    const { programId } = this.props.periods.find((period) => period.periodId === periodId);
    const studentId = await getCognitoId();
    const body = {
      basic,
      education: {
        colleges: []
      },
      other: {},
      points: {},
      status: constants.applicationStatuses.INCOMPLETE.code,
      programId,
      periodId,
      studentId,
      upgradeOption: false
    };
    this.props.dispatch({type: actions.CREATE_APPLICATION_REQUEST, application: body});
  }

  handleDismissAlert(id) {
    this.props.dispatch(removeAlert(id))
  }

  componentDidMount() {
    debugLog('App componentDidMount');
    //this.props.dispatch(authUser());

    fetchPeriods(this.props.dispatch);

    if(this.props.isLoginComplete) {
      debugLog('Setting user in component mount');
      this.setUser();
    }
  }

  async setUser() {
    const fetchResult = await fetchStudent(this.props.dispatch);
    let createInterval = false;
    let destroyInterval = false;
    let user = {};
    if(fetchResult.status) {
      user = fetchResult.user;
      this.props.dispatch(setUser(user));
      if(!user.complete) {
        console.log('User found but not complete. Recheck in 5 seconds');
        createInterval = true;
      } else
        destroyInterval = true;
    } else {
      if(fetchResult.reason === constants.REASON_NOT_FOUND) {
        console.log('User not found, creating new user');
        this.props.dispatch(setNewUser());
        const createResult = await createStudent(this.props.dispatch);
        if (createResult.status) {
          user = createResult.user;
          if (user.complete) {
            console.log('User created and complete. Done rechecking');
            destroyInterval = true;
          } else {
            console.log('User created but not complete. Recheck in 5 seconds');
            createInterval = true;
          }
          this.props.dispatch(setUser(user));
        } else {
          this.props.dispatch(addAlert('danger', createResult.reason.status));
        }
      } else {
        this.props.dispatch(addAlert('danger', fetchResult.reason));
      }
    }
    if(createInterval && !this.state.intervalId){
      let intervalId = setInterval(this.setUser, constants.RECHECK_INTERVAL);
      this.setState({intervalId});
    }
    if(destroyInterval && this.state.intervalId) {
      console.log('Stopping rechecks');
      clearInterval(this.state.intervalId);
    }
    return user;
  }

  componentDidUpdate(prevProps) {
    if(this.props.isLoginComplete && !prevProps.isLoginComplete) {
      debugLog('Setting user in component update');
      this.setUser();
    }
  }

  componentWillUnmount() {
    if(this.state.intervalId)
      clearInterval(this.state.intervalId);
  }

  render() {
    const { isLoginComplete, passcode, dispatch, user, userSet, periods, email, isInvoking, invokingMessage, alerts, newUser } = this.props;
    const InformedInformation = (props) => {
      return (
        <Information
          {...props}
          isAuthenticated={isLoginComplete}
          user={user}
          periods={periods}
          userSet={userSet}
          newUser={newUser}
        />
      )
    };
    const AppliedApplications = (props) => {
      return (
        <Applications
          {...props}
          user={user}
          isLoginComplete={isLoginComplete}
          userSet={userSet}
          periods={periods}
        />
      )
    };
    return (
        <Security oktaAuth={oktaConfig.oktaAuth} restoreOriginalUri={this.restoreOriginalUri}>
          <div>
            <Menu />
            <Grid>
              <Notifications
                isInvoking={isInvoking}
                invokingMessage={invokingMessage}
                alerts={alerts}
                onDismissAlert={this.handleDismissAlert}
                newUser={newUser}
              />
              <Switch>
                <Route exact path="/" component={InformedInformation} />
                <Route path="/information" component={InformedInformation} />
                <SecureRoute path="/applications" component={AppliedApplications} />
                <SecureRoute path="/create/:periodId"
                       render={(props) => (
                         <ApplicationInformation {...props}
                                                 periods={periods}
                                                 studentEmail={email}
                                                 user={user}
                                                 userSet={userSet}
                                                 newUser={newUser}
                                                 passcode={passcode}
                                                 dispatch={dispatch}
                                                 onCreateApplication={this.handleCreateApplication}
                         />)
                       }
                />
                <SecureRoute path="/form/:applicationId" component={ApplicationForm} />
                <SecureRoute path="/form" component={ApplicationForm} />
                <SecureRoute path="/application/:applicationId" component={Application} />
                <Route path="/login" component={LoginCallback} />
                <Route path="/initiate" component={Initiate} />
                <Redirect to="/" />
              </Switch>
            </Grid>
            <Footer/>
          </div>
        </Security>

    );
  }
}

function mapStateToProps(state) {
  const { auth, appInfo, application } = state;
  const { isLoginComplete, errorMessage, isFetching, user, userSet } = auth;
  const { applicationPeriods, isInvoking, alerts, newUser } = appInfo;
  const { passcode } = application;
  const email = user ? user.email : '';
  const invokingMessage = messages[appInfo.invokingMessage] ? messages[appInfo.invokingMessage] : appInfo.invokingMessage;
  return {
    isLoginComplete,
    errorMessage,
    isFetching,
    user,
    userSet,
    periods: applicationPeriods,
    email,
    alerts,
    invokingMessage,
    isInvoking,
    newUser,
    passcode
  }
}

export default connect(mapStateToProps)(withRouter(App))